// @ts-nocheck
import dataReducer, { StoreDataActions } from "@store/Framework/Store/Store/Data/DataReducer";
import { combineReducers } from "redux";

const storeReducers = combineReducers({
    data: dataReducer,
});

export type StoreActions = StoreDataActions;
export default storeReducers;
